module.exports = __webpack_public_path__ + "9d77a9108859a24930aefe93fb9f606a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/around/sun.png
// module id = 1160
// module chunks = 0